import axiosInstance from '../utils/axios';

/**
 * 비밀번호 정책 관리 서비스
 * 비밀번호 정책 조회 및 업데이트 기능을 제공합니다.
 */
const passwordPolicyService = {
  /**
   * 비밀번호 정책 정보 조회
   * 
   * @returns {Promise<Object>} 비밀번호 정책 정보
   */
  getPolicies: async () => {
    try {
      const response = await axiosInstance.get('/settings/password-policies');
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || '정책 정보를 불러오는데 실패했습니다.');
      }
    } catch (error) {
      console.error('비밀번호 정책 조회 오류:', error);
      throw error;
    }
  },
  
  /**
   * 비밀번호 정책 업데이트
   * 
   * @param {number} adminDays - 관리자 비밀번호 유효기간 (일)
   * @param {number} userDays - 일반 사용자 비밀번호 유효기간 (일)
   * @returns {Promise<Object>} 업데이트 결과
   */
  updatePolicies: async (adminDays, userDays) => {
    try {
      const response = await axiosInstance.put('/settings/password-policies', {
        admin_days: adminDays,
        user_days: userDays
      });
      
      if (response.data.success) {
        return { success: true, message: '비밀번호 정책이 성공적으로 변경되었습니다.' };
      } else {
        throw new Error(response.data.message || '정책 변경에 실패했습니다.');
      }
    } catch (error) {
      console.error('비밀번호 정책 업데이트 오류:', error);
      throw error;
    }
  }
};

export default passwordPolicyService;
